export const manufacturerIntegers = [];
export const manufacturerFloats = [];
export const manufacturerIsoStrings = [];
export const manufacturerWhiteList = ['id', 'name'];
export const manufacturerOptimisticList = [
  ...manufacturerWhiteList,
  'supplierCatalogItems',
];
